import {
    Component,
    OnChanges,
    OnInit,
    SimpleChanges,
  } from '@angular/core';
  import { BehaviorSubject } from 'rxjs';
  import { AuditLog, AuditType } from '../../../model/audit-history';
  import { AuditService } from '../../../services/audit.service';
import { LoadingController, NavParams, ToastController, ViewController } from 'ionic-angular';
  
  @Component({
    selector: 'app-audit-history',
    templateUrl: './audit-history.html'
  })
  export class AuditHistoryPage implements OnInit, OnChanges {
    private _auditHistory = new BehaviorSubject<AuditLog[]>([]);
    auditHistory = this._auditHistory.asObservable();
  
    auditHistoryDictionary: {
        [id: number]: { oldValues?: any[]; newValues?: any[] };
    } = {};
  
    config: {
        entityName: string;
        entityId: any;
    }[] = [];
      
    pageTitle: string;

    constructor(
      private navParams: NavParams,
      private auditService: AuditService,
      private loadingCtrl: LoadingController,
      private toastCtrl: ToastController,
      private viewCtrl: ViewController) { }
  
    async ngOnInit() {
        const loader = this.loadingCtrl.create({
            content: 'Loading audit history...',
        })

        loader.present();
            this.config = this.navParams.get('config');
            this.pageTitle = this.navParams.get('pageTitle');
        // console.log('config', this.config);

        try {
            await this.getAuditHistory();
        } catch (err) {
            console.error('Error getting audit history:', err);
            this.toastCtrl.create({ message: 'Error getting audit history.', duration: 2500 }).present();
        }
        loader.dismiss();
    }

    async ngOnChanges(changes: SimpleChanges) {
        await this.getAuditHistory();
    }
  
    public async refresh() {
        await this.getAuditHistory();
    }
  
    getAction(value: number): string | null {
        return AuditType[value] || null;
    }

    close() {
        this.viewCtrl.dismiss();
    }
  
    private async getAuditHistory() {
        if (!this.config) {
            return;
        }
  
        const auditHistory = await this.auditService.getAuditHistory([...this.config]);
        this._auditHistory.next(auditHistory);
        // console.log('AUDIT HISTORY SET');
        if (auditHistory) {
            //put start-endtimes on statuses. add statuses if in logs
            auditHistory.forEach((log) => {
            this.auditHistoryDictionary[log.id as number] = {};
            let newValues: any;
            let oldValues: any;
            // const optionsetConfig = this.config.find(x => x.entityName == log.tableName).optionsetConfig;
    
            if (log.newValues) {
                newValues = JSON.parse(log.newValues);
                this.auditHistoryDictionary[log.id as number].newValues = [];
                Object.keys(newValues).forEach((name) => {
                if (name !== 'ModifiedOn' && name !== 'ModifiedBy') {
                    let value = newValues[name];
                    if (!value && !log.oldValues) {
                    //skip logs with no value if it's the initial log
                    } else {
                    // if (optionsetConfig && optionsetConfig[name]) {
                    //   value = optionsetConfig[name].find(x => x.id == value).displayName;
                    // }
                    this.auditHistoryDictionary[log.id as number].newValues.push({
                        name,
                        value,
                        isExpanded: false
                    });
                    }
                }
                });
            }
            if (log.oldValues) {
                oldValues = JSON.parse(log.oldValues);
                this.auditHistoryDictionary[log.id as number].oldValues = [];
                Object.keys(oldValues).forEach((name) => {
                if (name !== 'ModifiedOn' && name !== 'ModifiedBy') {
                    let value = oldValues[name];
                    // if (optionsetConfig && optionsetConfig[name]) {
                    //   value = optionsetConfig[name].find(x => x.id == value).displayName;
                    // }
                    this.auditHistoryDictionary[log.id as number].oldValues.push({
                    name,
                    value,
                    isExpanded: false
                    });
                }
                });
            }
            });
            // console.log(this.auditHistoryDictionary);
        }
    }
  }
  


// WEBPACK FOOTER //
// ./src/pages/staff/audit-history/audit-history.ts